  const EASE_OUT = 'cubic-bezier(0.23, 1, 0.32, 1)';
  const CROSSFADE_MS = 200;

  const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const cancelAnimations = (el) => {
    el.getAnimations().forEach((animation) => animation.cancel());
  };

  const crossfadePrimaryImage = (primaryImage, newPrimaryImage, secondaryImage) => {
    cancelAnimations(primaryImage);

    if (prefersReducedMotion()) {
      primaryImage.replaceWith(newPrimaryImage);
      if (secondaryImage) secondaryImage.remove();
      return;
    }

    const fadeOut = primaryImage.animate(
      { opacity: [1, 0] },
      { duration: CROSSFADE_MS, easing: EASE_OUT, fill: 'forwards' }
    );

    fadeOut.onfinish = () => {
      primaryImage.replaceWith(newPrimaryImage);
      newPrimaryImage.style.opacity = '0';
      newPrimaryImage.animate(
        { opacity: [0, 1] },
        { duration: CROSSFADE_MS, easing: EASE_OUT, fill: 'forwards' }
      );
      if (secondaryImage) secondaryImage.remove();
    };
  };

  const generateSrcset = (image, widths = []) => {
    const imageUrl = new URL(image["src"]);
    return widths.filter((width) => width <= image["width"]).map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    }).join(", ");
  }

  const createImageElement = (image, classes, sizes, productTitle) => {
    const previewImage = image["preview_image"];
    const newImage = new Image(previewImage["width"], previewImage["height"]);
    newImage.className = classes;
    newImage.alt = image["alt"] || productTitle;
    newImage.sizes = sizes;
    newImage.src = previewImage["src"];
    newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
    newImage.loading="lazy"
    return newImage;
  }

  const checkSwatches = () => {
    document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
      wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
        input.addEventListener('click', (event) => {
          const primaryImage = wrapper.querySelector(".media--first");
          const secondaryImage = wrapper.querySelector(".media--second");
          const handleProduct = wrapper.dataset.product;
          
          if (event.currentTarget.checked && primaryImage) {
            wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
            const currentColor = event.currentTarget.value;

            fetch(window.Shopify.routes.root + `products/${handleProduct}.js`)
              .then((response) => {
                if (!response.ok) throw new Error('Failed to load product');
                return response.json();
              })
              .then((product) => {
                const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];
                if (variant) {
                  const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);

                  if (newPrimaryImage.src !== primaryImage.src) {
                    let flag = false;
                    if (secondaryImage) {
                      const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                      const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                      if (secondaryImagePathname == newPrimaryImagePathname) {
                        primaryImage.remove();
                        secondaryImage.classList.remove('media--second');
                        secondaryImage.classList.add('media--first');
                        flag = true;
                      }
                    }
                    if (flag == false) {
                      crossfadePrimaryImage(primaryImage, newPrimaryImage, secondaryImage);
                    }
                  }
                }
              })
              .catch(() => {});
          }
        })
      })
    })
  }

  function colorSwatches() {
    checkSwatches();

    document.addEventListener('shopify:section:load', function () {
      checkSwatches();
    });
  }

(function () {
  colorSwatches();
})()
